<template>
    <section class="padding-vertical-content mb-3 mb-lg-4">
        <div class="container">
            <div class="mb-4 h3 text-uppercase">{{ $t('compra.confirmacion_compra') }}</div>
            <PagoPaycometComponent
                ref="pago"
                tipo_venta="base"
                :jet_id="base.jet_id"
                :session_id="base.categoria_base.session_id"
            />
        </div>
    </section>
</template>

<script>
    import PagoPaycometComponent from "@/components/frontend/compra/components/PagoPaycometComponent";

    export default {
        props: ['base'],
        beforeDestroy() {
            this.$refs.pago.clearAllIntervals();
        },
        components: {
            PagoPaycometComponent
        }
    }
</script>